import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getNotifications } from '../api'

export const useGetNotificationsOnMount = () => {
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      await dispatch(getNotifications())
      if (mounted) {
        setLoading(false)
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return loading
}
